var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useContext, useEffect } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { useSearchParams, Navigate } from 'react-router-dom';
import { checkEmailExistsInOneAccount, searchUsers } from '../api';
import ApiContext from '../contexts/apiContext';
import UserContext from '../contexts/userContext';
import ErrorDialog from './ErrorDialog';
import UserList from './UserList';
import Header from './Header';
var USER_ROLE = 'RegistrationAdminTool_User';
var MAILTO_PSEUDOPROTOCOL = 'mailto:';
var UserSearch = function () {
    var _a, _b;
    var _c = useSearchParams(), searchParams = _c[0], setSearchParams = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState((_a = searchParams.get('query')) !== null && _a !== void 0 ? _a : ''), query = _e[0], setQuery = _e[1];
    var _f = useState(undefined), searchResults = _f[0], setSearchResults = _f[1];
    var _g = useState(), oneAccountEmailFound = _g[0], setOneAccountEmailFound = _g[1];
    var _h = useState(), errorMessage = _h[0], setErrorMessage = _h[1];
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    var user = useContext(UserContext).user;
    useEffect(function () {
        if (query === null || query === void 0 ? void 0 : query.trim()) {
            search();
        }
    }, []);
    var search = function () {
        var newSearchParams = new URLSearchParams();
        var trimmedQuery = query.trim();
        var fixedQuery = trimmedQuery.startsWith(MAILTO_PSEUDOPROTOCOL)
            ? trimmedQuery.slice(MAILTO_PSEUDOPROTOCOL.length)
            : trimmedQuery;
        newSearchParams.set('query', fixedQuery);
        setSearchParams(newSearchParams);
        setSearchResults([]);
        setOneAccountEmailFound(false);
        setLoading(true);
        searchUsers(apiBaseUrl, fixedQuery)
            .then(function (searchResulsResult) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setSearchResults(searchResulsResult);
                if (searchResulsResult.length === 0 && fixedQuery.includes('@')) {
                    return [2 /*return*/, checkEmailExistsInOneAccount(apiBaseUrl, fixedQuery)
                            .then(function (emailCheckResult) { return setOneAccountEmailFound(emailCheckResult.found); })
                            .catch(function () { })];
                }
                return [2 /*return*/];
            });
        }); })
            .catch(function () { return setErrorMessage('Error getting results, please try again later'); })
            .finally(function () { return setLoading(false); });
    };
    var handleQueryChange = function (e) { return setQuery(e.target.value.slice(0, 2000)); };
    var handleSendKeyDown = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (e.key !== 'Enter' || e.shiftKey) {
                return [2 /*return*/];
            }
            e.preventDefault();
            if (!query.trim()) {
                return [2 /*return*/];
            }
            return [2 /*return*/, search()];
        });
    }); };
    var handleSendClick = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, search()];
    }); }); };
    var handleSendMouseDown = function (e) { return e.preventDefault(); };
    var handleErrorDialogClose = function () { return setErrorMessage(undefined); };
    if (!((_b = user === null || user === void 0 ? void 0 : user.roles) === null || _b === void 0 ? void 0 : _b.includes(USER_ROLE))) {
        return _jsx(Navigate, { to: "/forbidden", replace: true });
    }
    return (_jsxs(Box, { children: [_jsx(Header, {}), _jsx(ErrorDialog, { message: errorMessage, onClose: handleErrorDialogClose }), loading && (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh", children: _jsx(CircularProgress, {}) })), !loading && (_jsxs(Box, { display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh", children: [!searchResults && (_jsx(TextField, { autoFocus: true, placeholder: "Enter email address, display name or user id", inputProps: { maxLength: 2000 }, value: query, onChange: handleQueryChange, onKeyDown: handleSendKeyDown, sx: { backgroundColor: 'white', width: '500px' }, InputProps: {
                            endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { disabled: !query.trim(), onClick: handleSendClick, onMouseDown: handleSendMouseDown, edge: "end", children: _jsx(SearchIcon, {}) }) }))
                        } })), searchResults && searchResults.length === 0 && !oneAccountEmailFound && (_jsx(Alert, { severity: "warning", children: "No results found" })), searchResults && searchResults.length === 0 && oneAccountEmailFound && (_jsx(Alert, { severity: "warning", children: "No results found in MailOnline but the email address was found in OneAccount" })), searchResults && searchResults.length === 1 && _jsx(Navigate, { to: "/users/".concat(searchResults[0].id), replace: true }), searchResults && searchResults.length > 1 && _jsx(UserList, { users: searchResults })] }))] }));
};
export default UserSearch;
